// extracted by mini-css-extract-plugin
export default {"boardContainer":"DailyCheckListBoard_boardContainer__7Vb48"};